import cn from 'classnames'
import { useId } from 'react'

import styles from './Tooltip.module.scss'

type X = 'left' | 'center' | 'right'
type Y = 'top' | 'center' | 'bottom'

type Position<X, Y> = X extends 'center'
  ? Y extends 'center'
    ? never
    : { x: X; y: Y }
  : { x: X; y: Y }

const getArrowClassByPosition = ({ x, y }: Position<X, Y>) => {
  const positionMap = {
    top: {
      left: styles.arrowTopLeft,
      center: styles.arrowTopCenter,
      right: styles.arrowTopRight,
    },
    center: {
      left: styles.arrowCenterLeft,
      right: styles.arrowCenterRight,
    },
    bottom: {
      left: styles.arrowBottomLeft,
      center: styles.arrowBottomCenter,
      right: styles.arrowBottomRight,
    },
  } as const

  return positionMap[y as keyof typeof positionMap][
    x as keyof (typeof positionMap)[keyof typeof positionMap]
  ]
}

type TooltipProps = Position<X, Y> & {
  children: React.ReactNode
  className?: string
}

export const TooltipContent = ({
  x = 'left',
  y = 'top',
  className,
  children,
}: TooltipProps) => {
  const id = useId()

  return (
    <div className={cn(styles.container, className)}>
      <svg fill="none" className={styles.svg} key={children?.toString()}>
        <g filter={`url(#${id})`}>
          <rect
            y="7"
            x="8"
            width="calc(100% - 11rem)"
            height="calc(100% - 11rem)"
            rx="10"
            fill="black"
          />
          <path
            d="M2.83 11C1.05 11 0.15 8.85 1.41 7.59L7.59 1.41C8.37 0.63 9.63 0.63 10.41 1.41L16.59 7.59C17.85 8.85 16.95 11 15.17 11H2.83Z"
            className={cn(
              styles.arrow,
              getArrowClassByPosition({ x, y } as Position<X, Y>)
            )}
            fill="black"
          />
        </g>
        <defs>
          <filter
            id={id}
            x="0"
            y="0.82"
            width="100%"
            height="100%"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2.5" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_4936_11812"
            />
          </filter>
        </defs>
      </svg>
      {/* // нужен для корректного размера svg */}
      <div className={cn(styles.text, styles.hiddenText)}>{children}</div>
      <div className={cn(styles.text, styles.visibleText)}>{children}</div>
    </div>
  )
}
